import { Component } from 'react';
import * as React from 'react';
import { ClinicSelectComponent } from './ClinicSelect';
import { ClinicListComponent } from './ClinicList';
import { IClinicListItem } from '../../models/IClinicListItem';
import { ClinicService } from '../../services/ClinicService';
import { Redirect } from 'react-router';

interface IProps {
    PhysiotherapistId?: string,
    Clinics?: IClinicListItem[],
    OnRefreshRequired?: () => void,
    ShowClinicOnMap?: (clinic: IClinicListItem) => void
}

interface IState {
    ShowSelectClinicComponent: boolean,
    Clinics: IClinicListItem[],
    RedirectToAdd: boolean
}

export class ClinicSectionComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            ShowSelectClinicComponent: false,
            Clinics: this.props.Clinics ? this.props.Clinics : [],
            RedirectToAdd: false
        }

        this.AddNewClinicClick = this.AddNewClinicClick.bind(this);
        this.SelectClinicClick = this.SelectClinicClick.bind(this);
        this.OnSelectClinic = this.OnSelectClinic.bind(this);
        this.OnAddNewClinicSuccess = this.OnAddNewClinicSuccess.bind(this);
        this.OnAddNewClinicError = this.OnAddNewClinicError.bind(this);
        this.RefreshClinicsListData = this.RefreshClinicsListData.bind(this);
        this.OnGetClinicListItemsSuccess = this.OnGetClinicListItemsSuccess.bind(this);
        this.OnGetClinicListItemsError = this.OnGetClinicListItemsError.bind(this);

        this.RefreshClinicsListData();
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.Clinics) {
            this.setState({
                Clinics: nextProps.Clinics
            });
        }
    }

    public render() {
        return (
            <div className="clinic-section-component">
                {this.RenderRedirect()}
                {this.RenderSelectClinicComponent()}
                <div>
                    <ClinicListComponent
                        Items={this.state.Clinics}
                        OnRefreshRequired={this.RefreshClinicsListData}
                        PhysiotherapistId={this.props.PhysiotherapistId}
                        ShowClinicOnMap={this.props.ShowClinicOnMap} />
                </div>
            </div>
        );
    }

    private RenderRedirect() {
        if (this.state.RedirectToAdd) {
            return <Redirect to={'/addclinic'} push={true} />
        } else {
            return null;
        }
    }

    private RenderSelectClinicComponent() {
        if (this.state.ShowSelectClinicComponent) {
            return (
                <ClinicSelectComponent OnSelect={this.OnSelectClinic} />
            );
        } else {
            return null;
        }
    }

    private AddNewClinicClick() {
        this.setState({
            RedirectToAdd: true
        });
    }

    private SelectClinicClick(e) {
        this.setState({
            ShowSelectClinicComponent: true
        });
    }

    private OnSelectClinic(selectedId: number) {
        //let service = new ClinicService();
        //service.AddMyClinic(selectedId, this.OnAddNewClinicSuccess, this.OnAddNewClinicError);
    }

    private OnAddNewClinicSuccess(result) {
        this.setState({
            ShowSelectClinicComponent: false
        });
        this.RefreshClinicsListData();
    }

    private OnAddNewClinicError(error) {
        console.error(error);
    }

    private RefreshClinicsListData() {
        if (this.props.Clinics === undefined) {
            let service = new ClinicService();
            if (this.props.PhysiotherapistId) {
                service.GetPhysiotherapistsClinics(this.props.PhysiotherapistId, this.OnGetClinicListItemsSuccess, this.OnGetClinicListItemsError);
            } else {
                service.GetMyClinicsList(this.OnGetClinicListItemsSuccess, this.OnGetClinicListItemsError);
            }
        } else {
            if (this.props.OnRefreshRequired) {
                this.props.OnRefreshRequired();
            }
        }
    }

    private OnGetClinicListItemsSuccess(result): void {
        this.setState({
            Clinics: result.data.Value
        });
    }

    private OnGetClinicListItemsError(error): void {
        console.error(error);
    }
}


// WEBPACK FOOTER //
// ./src/components/Clinic/ClinicSection.tsx